import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import * as localForage from 'localforage';

@Injectable()

export class AcceptKeyGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // if (localStorage.getItem('_acceptKey')) {
    //     return true;
    // }
    // this.router.navigate(['']);
    // return false;
    return new Promise(res => {
      localForage.getItem('_acceptKey').then(result => {
        if (result) {
          console.log(result);
          var user;
          localForage.getItem('_user').then(data => {
            user = data;
            var quayban;
            quayban = localStorage.getItem('_dtQBan');
            if (user !== null && quayban !== null) {
              this.router.navigate(['banhang']);
              res(false);
            }
            if (user == null && quayban !== null) {
              this.router.navigate(['signin']);
              res(false);
            }
            else {
              res(true);
            }   
          });
           
        } else {
          this.router.navigate(['']);
          res(false);
        }
      }).catch(err => res(false));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/acceptKey.guard.ts